import AWS from 'aws-sdk';
import { environment } from '@environment/environment';
const DEV = false

export abstract class AwsBase {

    constructor() {
        const { identityPoolId, region } = environment.aws
        AWS.config.region = region;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
        });
    }
    /**
     * get s3 instance
     */
    getS3() {
        const { apiVersion, region, isAccelerate } = environment.aws.s3;
        let option:AWS.S3.ClientConfiguration = {
            apiVersion: apiVersion,
            region: region,
            httpOptions: {
                timeout: 0
            }
        };
        if (!environment.production && DEV) {
            option.region = 'eu-west-1'
            option['endpoint'] = 'http://localhost:5002'
            option['s3ForcePathStyle'] = true
        }
        if (isAccelerate) {
            option['endpoint'] = `https://s3-accelerate.amazonaws.com`
        }
        return new AWS.S3(option);
    }

}